import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-drawer',
  standalone: false,
  templateUrl: './drawer.html',
  styleUrl: './drawer.scss',
})
export class Drawer {
  @Input({ required: true }) open = false;
  @Input({ required: true }) title = '';
  @Input() width = 400;
  @Output() close = new EventEmitter<void>();

  protected onBackdropClick() {
    this.close.emit();
  }
}
